module.exports = __webpack_public_path__ + "img/MIXTRA_LOGO.c4d7f71c.png";